import { cn } from "@/lib/cn";

export function ToggleDot({ enabled }: { enabled: boolean }) {
  return (
    <div
      className={cn(
        "h-3 w-3 rounded-full transition-colors",
        enabled ? "bg-emerald-400" : "bg-[var(--color-border)]",
      )}
    />
  );
}
